import { render, staticRenderFns } from "./page-intro.vue?vue&type=template&id=532a340f"
var script = {}
import style0 from "./page-intro.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports